export class GcsSourceProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bucket",
            "baseName": "bucket",
            "type": "string",
            "format": ""
        },
        {
            "name": "prefix",
            "baseName": "prefix",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": ""
        },
        {
            "name": "fileFormat",
            "baseName": "fileFormat",
            "type": "FileFormat",
            "format": ""
        },
        {
            "name": "partitionType",
            "baseName": "partitionType",
            "type": "PartitionType",
            "format": ""
        },
        {
            "name": "bucketPathPartitionSpec",
            "baseName": "bucketPathPartitionSpec",
            "type": "BucketPathPartitionSpec",
            "format": ""
        },
        {
            "name": "partitionFields",
            "baseName": "partitionFields",
            "type": "Array<PartitionField>",
            "format": ""
        },
        {
            "name": "schemaOverrides",
            "baseName": "schemaOverrides",
            "type": "Array<FieldOverride>",
            "format": ""
        },
        {
            "name": "sourceSubscriptionId",
            "baseName": "sourceSubscriptionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "routeRules",
            "baseName": "routeRules",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "othersLane",
            "baseName": "othersLane",
            "type": "string",
            "format": ""
        },
        {
            "name": "autoCreateTargets",
            "baseName": "autoCreateTargets",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "targetProjectId",
            "baseName": "targetProjectId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcsSourceProperties.attributeTypeMap;
    }
    constructor() {
    }
}
